import announcementAPI from "../api/announcementAPI";

const search = async (params) => {
    try {
        const result = await announcementAPI.search(params)

        if (result) {
            return result
        } else {
            return []
        }

    } catch (err) {
        throw err
    }
}

const save = async (params) => {
    try {
        const result = await announcementAPI.save(params)
        return result

    } catch (err) {
        throw err
    }
}

const update = async (params) => {
    try {
        const result = await announcementAPI.update(params)
        return result

    } catch (err) {
        throw err
    }
}

const getById = async (params) => {
    try {
        const result = await announcementAPI.getById(params)
        return result

    } catch (err) {
        throw err
    }
}

// user (announcement) read receipt
const getUnreadAnnouncementById = async (params) => {
    try {
        const result = await announcementAPI.getUnreadAnnouncementById(params)
        return result

    } catch (err) {
        throw err
    }
}

const updateUserReadReceipt = async (params) => {
    try {
        const result = await announcementAPI.updateUserReadReceipt(params)
        return result

    } catch (err) {
        throw err
    }
}


export default {
    search: search,
    save: save,
    update: update,
    getById: getById,
    getUnreadAnnouncementById: getUnreadAnnouncementById,
    updateUserReadReceipt: updateUserReadReceipt,
}